import React, { useMemo, useState, useEffect } from "react";
import { IoArrowBackSharp, IoCheckmarkCircleOutline } from "react-icons/io5";
import { Modal } from "antd";
import {
  useGetDreamRoleData,
  useGetInterviewTypeData,
  useInitiatePayment,
} from "../Hooks/AssesmentHooks";
import { useNavigate } from "react-router-dom";
import HireHubHeader from "./HireHubHeader";
import { interview_types } from "../Utils/constants";
import jwtEncode from "jwt-encode";

const HireHubRolePicker = () => {
  const currentUser = localStorage.getItem("candidate");
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (selectedRole) setIsModalOpen(true);
  }, [selectedRole]);

  const colors = [
    "bg-purple-500",
    "bg-blue-500",
    "bg-teal-500",
    "bg-orange-500",
    "bg-pink-500",
    "bg-indigo-500",
    "bg-cyan-500",
    "bg-red-500",
    "bg-purple-600",
  ];

  const roles = [
    {
      id: 1,
      category: "DATA & ANALYTICS",
      title: "Data Analyst / Data Analytics",
      level: "Entry Level (Fresher)",
      description:
        "Master data analysis, visualization, and insights generation",
      color: "bg-purple-500",
      icon: "📊",
    },
    {
      id: 2,
      category: "DATA SCIENCE",
      title: "Data Scientist",
      level: "Entry Level / Fresher",
      description:
        "Learn statistical modeling, machine learning, and data storytelling",
      color: "bg-blue-500",
      icon: "📊",
    },
    {
      id: 3,
      category: "ARTIFICIAL INTELLIGENCE",
      title: "AI/ML Engineer",
      level: "Fresher / Entry Level",
      description: "Build and deploy machine learning models and AI solutions",
      color: "bg-teal-500",
      icon: "📊",
    },
    {
      id: 4,
      category: "AI SOLUTIONS",
      title: "AI Generalist / AI Solutions Engineer",
      level: "Entry Level",
      description: "Design end-to-end AI solutions for business problems",
      color: "bg-orange-500",
      icon: "📊",
    },
    {
      id: 5,
      category: "SOFTWARE DEVELOPMENT",
      title: "Python Programmer",
      level: "Entry Level / Fresher",
      description: "Develop applications and scripts using Python programming",
      color: "bg-pink-500",
      icon: "📊",
    },
    {
      id: 6,
      category: "BUSINESS INTELLIGENCE",
      title: "Business Intelligence Analyst",
      level: "Excel/Power-BI/SQL",
      description:
        "Transform data into actionable business insights using BI tools",
      color: "bg-indigo-500",
      icon: "📊",
    },
    {
      id: 7,
      category: "DEVOPS",
      title: "DevOps Engineer / Junior DevOps Engineer",
      level: "Entry Level",
      description: "Automate deployment pipelines and manage infrastructure",
      color: "bg-cyan-500",
      icon: "📊",
    },
    {
      id: 8,
      category: "CYBERSECURITY",
      title: "Cyber Security Analyst / Junior Cybersecurity Specialist",
      level: "Entry Level",
      description: "Protect systems and networks from security threats",
      color: "bg-red-500",
      icon: "📊",
    },
    {
      id: 9,
      category: "CLOUD COMPUTING",
      title: "Cloud Engineer / Junior Cloud Engineer",
      level: "Multi-Cloud - Entry Level",
      description: "Design and manage cloud infrastructure across platforms",
      color: "bg-purple-600",
      icon: "📊",
    },
  ];

  const {
    data: interviewTypesData,
    status: interviewTypesDataStatus,
    refetch: refetchinterviewTypeData,
    isLoading: loadingInterviewTypeData,
    isFetching: fetchingInterviewTypeData,
  } = useGetInterviewTypeData({
    params: {},
    // enabled: !!user_id,
  });

  const role_datas = useMemo(() => {
    if (!interviewTypesData?.interviews_payment_details) return [];
    return interviewTypesData?.interviews_payment_details?.filter(
      (item) => item.interview_type === interview_types?.dynamic,
    );
  }, [interviewTypesData]);

  console.log(role_datas, "role_datas");

  return (
    <>
      <div className="h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8 overflow-auto pt-0">
        {currentUser && (
          <div className="w-full flex items-center justify-between px-10">
            <p
              className="flex items-center gap-2 cursor-pointer font-semibold mr-2"
              onClick={() => {
                localStorage.removeItem("interview_type");
                navigate(-1);
              }}
            >
              <IoArrowBackSharp />
              Back
            </p>
            <HireHubHeader />
          </div>
        )}
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Pick Your Dream Role
            </h1>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              Select the position you're aiming for and we'll create a
              personalized interview experience
            </p>
          </div>

          {/* Role Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 pb-20">
            {role_datas.map((role, index) => (
              <div
                key={role?.job_details?.id}
                onClick={() => setSelectedRole(role)}
                className={`bg-white rounded-xl p-6 cursor-pointer transition-all duration-200 relative ${
                  selectedRole?.job_details?.id === role?.job_details?.id
                    ? "border-2 border-blue-400 shadow-lg ring-2 ring-blue-100"
                    : "border border-gray-200 hover:border-gray-300 hover:shadow-md"
                }`}
              >
                {/* Icon and Checkmark */}
                <div className="flex items-start justify-between">
                  {/* <div
                    className={`${colors[index % colors.length]} w-12 h-12 rounded-lg flex items-center justify-center text-white flex-shrink-0`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7499_5112)">
                        <path
                          d="M13.3346 16.666V3.33268C13.3346 2.89065 13.159 2.46673 12.8465 2.15417C12.5339 1.84161 12.11 1.66602 11.668 1.66602H8.33464C7.89261 1.66602 7.46869 1.84161 7.15612 2.15417C6.84356 2.46673 6.66797 2.89065 6.66797 3.33268V16.666"
                          stroke="white"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.668 5H3.33464C2.41416 5 1.66797 5.74619 1.66797 6.66667V15C1.66797 15.9205 2.41416 16.6667 3.33464 16.6667H16.668C17.5884 16.6667 18.3346 15.9205 18.3346 15V6.66667C18.3346 5.74619 17.5884 5 16.668 5Z"
                          stroke="white"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7499_5112">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div> */}
                  <div>
                    {role?.status !== "UNPAID" ||
                      (role?.status === "PAID" && !role?.attended_status && (
                        <div className="flex w-[63px] h-[21px] pl-[10px] items-center gap-[4px] rounded-full border-[0.8px] border-[#6CE5BD] bg-[rgba(208,250,229,0.45)]">
                          <svg
                            width="10"
                            height="7"
                            viewBox="0 0 10 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.667969 3.36491L3.36491 6.06185L8.75879 0.667969"
                              stroke="#009966"
                              stroke-width="1.33333"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span class="text-[#009966] font-['Poppins'] text-[10px] font-medium leading-[15px]">
                            Paid
                          </span>
                        </div>
                      ))}
                  </div>
                  <div className="flex items-center gap-3">
                    {selectedRole?.job_details?.id === role?.job_details?.id ? (
                      <div className="flex items-center justify-center rounded-full bg-[#0071DC]">
                        <IoCheckmarkCircleOutline className="text-white text-[24px] leading-none" />
                      </div>
                    ) : (
                      <div className="w-6 h-6 border-[1.6px] border-[#D1D5DC] rounded-full"></div>
                    )}
                  </div>
                </div>
                <div
                  className={`h-1 w-16 ${colors[index % colors.length]} rounded-lg my-4`}
                >
                  {" "}
                </div>
                {/* Category */}
                {/* <div className="mb-2">
                  <span className="text-xs font-semibold text-[#5D5D5D] uppercase tracking-wide flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7499_5304)">
                        <path
                          d="M4.80153 0.956857C4.81979 0.919965 4.848 0.888912 4.88297 0.867201C4.91794 0.845489 4.95828 0.833984 4.99945 0.833984C5.04061 0.833984 5.08095 0.845489 5.11593 0.867201C5.1509 0.888912 5.17911 0.919965 5.19736 0.956857L6.15986 2.90644C6.22327 3.03476 6.31687 3.14578 6.43263 3.22996C6.54838 3.31415 6.68283 3.36899 6.82445 3.38977L8.97695 3.70477C9.01773 3.71068 9.05605 3.72789 9.08757 3.75444C9.11909 3.78099 9.14254 3.81584 9.15529 3.85503C9.16804 3.89422 9.16956 3.93619 9.15969 3.97621C9.14982 4.01622 9.12896 4.05267 9.09945 4.08144L7.54278 5.59727C7.44012 5.69732 7.36331 5.82081 7.31896 5.95712C7.27461 6.09343 7.26406 6.23848 7.2882 6.37977L7.6557 8.52144C7.6629 8.56221 7.65849 8.60417 7.64299 8.64256C7.62748 8.68094 7.6015 8.71419 7.56801 8.73852C7.53451 8.76285 7.49486 8.77727 7.45356 8.78015C7.41226 8.78302 7.37099 8.77423 7.33445 8.75477L5.41028 7.74311C5.2835 7.67653 5.14244 7.64175 4.99924 7.64175C4.85604 7.64175 4.71498 7.67653 4.5882 7.74311L2.66445 8.75477C2.62792 8.77411 2.5867 8.78281 2.54547 8.77988C2.50424 8.77695 2.46466 8.76251 2.43124 8.7382C2.39781 8.71389 2.37188 8.68068 2.35639 8.64237C2.3409 8.60405 2.33647 8.56215 2.34361 8.52144L2.7107 6.38019C2.73495 6.23883 2.72444 6.09369 2.68009 5.95729C2.63574 5.8209 2.55887 5.69734 2.45611 5.59727L0.899448 4.08186C0.869695 4.05312 0.848612 4.0166 0.838599 3.97647C0.828586 3.93634 0.830047 3.8942 0.842814 3.85485C0.855581 3.81551 0.879142 3.78054 0.910813 3.75393C0.942484 3.72733 0.980991 3.71015 1.02195 3.70436L3.17403 3.38977C3.3158 3.36915 3.45044 3.31438 3.56636 3.23018C3.68227 3.14599 3.77599 3.03489 3.83945 2.90644L4.80153 0.956857Z"
                          stroke="#FE9A00"
                          stroke-width="0.833333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7499_5304">
                          <rect width="10" height="10" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>{" "}
                    {role?.job_details?.department}
                  </span>
                </div> */}

                {/* Title */}
                <h3 className="text-lg font-bold text-[#2E2C2C] mb-3 leading-tight">
                  {role?.job_details?.title}
                </h3>

                {/* Level Badge */}
                {/* <div className="mb-3">
                  <span className="inline-block bg-gray-100 text-gray-700 text-xs font-medium px-3 py-1.5 rounded-full">
                    {role?.job_details?.job_type}
                  </span>
                </div> */}

                {/* Description */}
                {/* <p className="text-sm text-gray-600 leading-relaxed">
                  {role?.job_details?.description}
                </p> */}
              </div>
            ))}
          </div>

          {/* Continue Button */}
          {/* {selectedRole && (
          <div className="mt-8 text-center animate-fadeIn">
            <button onClick={()=> navigate("/hirehub-talent")} className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg">
              Continue with Selected Role
            </button>
          </div>
        )} */}

          {/* Role Modal */}
          {selectedRole && (
            <Modal
              open={isModalOpen}
              onCancel={() => {
                setIsModalOpen(false);
                setSelectedRole(null);
              }}
              footer={null}
              centered
              width={500}
              mask={true}
              maskClosable={true}
              className="hirehub-role-modal p-0"
              getContainer={false}
            >
              <div className="max-w-[90%] mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col items-start gap-4">
                <div className="flex items-center gap-4">
                  {/* <div
                    className={`bg-[linear-gradient(135deg,#00BC7D_0%,#009689_100%)] shadow-[0_10px_15px_-3px_rgba(0,0,0,0.10),0_4px_6px_-4px_rgba(0,0,0,0.10)] w-12 h-12 rounded-lg flex items-center justify-center text-white flex-shrink-0`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M18.6654 23.332V4.66536C18.6654 4.04653 18.4195 3.45303 17.9819 3.01545C17.5444 2.57786 16.9509 2.33203 16.332 2.33203H11.6654C11.0465 2.33203 10.453 2.57786 10.0154 3.01545C9.57786 3.45303 9.33203 4.04653 9.33203 4.66536V23.332"
                        stroke="white"
                        stroke-width="2.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M23.332 7H4.66536C3.3767 7 2.33203 8.04467 2.33203 9.33333V21C2.33203 22.2887 3.3767 23.3333 4.66536 23.3333H23.332C24.6207 23.3333 25.6654 22.2887 25.6654 21V9.33333C25.6654 8.04467 24.6207 7 23.332 7Z"
                        stroke="white"
                        stroke-width="2.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div> */}
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">
                      Selected Role
                    </p>
                    <p className="text-base font-bold text-gray-900 leading-tight">
                      {selectedRole?.job_details?.title}
                    </p>
                    <p className="text-xs text-orange-500 mt-0.5 flex items-center gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_7519_5317)">
                          <path
                            d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                            stroke="#E17100"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6 3V6L8 7"
                            stroke="#E17100"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_7519_5317">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Your interview plan will expire with in 7 days
                    </p>
                  </div>
                </div>

                <div className="flex items-center justify-between w-full">
                  <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">
                      Assessment Price
                    </p>
                    <p className="text-2xl font-bold text-gray-900">
                      ₹{selectedRole?.fee}
                    </p>
                  </div>

                  <div>
                    {selectedRole?.status === "UNPAID" ||
                    (selectedRole?.status === "PAID" &&
                      selectedRole?.attended_status) ? (
                      <button
                        className="bg-[#0071DC] p-2 px-8 text-white font-bold rounded-md"
                        onClick={() => {
                          const token = jwtEncode(selectedRole, "");
                          console.log(token, "token>>?");

                          window.open(
                            `https://hirehub.ipecsolutions.com/payment-checkout?token=${token}`,
                            "_blank",
                          );
                        }}
                      >
                        Pay Now
                      </button>
                    ) : (
                      <button
                        className="bg-[#1229fa] p-2 px-8 text-white font-bold rounded-md"
                        onClick={() =>
                          window.open(selectedRole?.link, "_blank")
                        }
                      >
                        Start Interview
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </Modal>
          )}
        </div>

        <style jsx>{`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes scaleIn {
            from {
              opacity: 0;
              transform: scale(0.5);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          .animate-fadeIn {
            animation: fadeIn 0.3s ease-in-out;
          }

          .animate-scaleIn {
            animation: scaleIn 0.2s ease-out;
          }
        `}</style>
      </div>
    </>
  );
};

export default HireHubRolePicker;
